import React from 'react'
import { number, string, shape, oneOfType } from 'prop-types'
import { FormattedMessage } from 'react-intl'
import CurrencyFormat from 'react-currency-format'

import Divider from '@components/Divider'

import useInternationalization from '@hooks/useInternationalization'

import { runningGirl } from '@assets'

import * as Style from './OfferCard.style'

export default function Card({ contact }) {
  const {
    formats: { currency },
  } = useInternationalization()

  return (
    <Style.Card>
      <Style.CardHeader>
        <Style.CardTitle>
          <FormattedMessage id="smb_acquisition_checkout_summary.title.summary" />
        </Style.CardTitle>
      </Style.CardHeader>

      <Style.CardContent>
        <Style.PriceRow>
          <Style.PriceDescription>
            <FormattedMessage
              id="smb_acquisition_checkout_summary.description.benefit_value"
              values={{
                numberOfEmployees: <strong>{contact.employeesNumber}</strong>,
              }}
            />
          </Style.PriceDescription>
          <Style.PriceValue>
            <CurrencyFormat
              prefix={currency.moneySign}
              value={contact.proposalValueWithoutDiscount}
              displayType="text"
              thousandSeparator={currency.thousandSeparator}
              decimalSeparator={currency.decimalSeparator}
              decimalScale={2}
              fixedDecimalScale
            />
          </Style.PriceValue>
        </Style.PriceRow>

        {contact.discount < 0 && (
          <Style.PriceRow>
            <Style.PriceDescription>
              <FormattedMessage id="smb_acquisition_checkout_summary.description.discount_coupon" />
            </Style.PriceDescription>
            <Style.PriceValue isDiscount>
              <CurrencyFormat
                prefix={currency.moneySign}
                value={contact.discount < 0 ? contact.discount : 0}
                displayType="text"
                thousandSeparator={currency.thousandSeparator}
                decimalSeparator={currency.decimalSeparator}
                decimalScale={2}
                fixedDecimalScale
              />
            </Style.PriceValue>
          </Style.PriceRow>
        )}

        <Style.DividerWrapper>
          <Divider />
        </Style.DividerWrapper>

        <Style.PriceRow>
          <Style.PriceDescription>
            <span>
              <FormattedMessage id="smb_acquisition_checkout_summary.description.total_value" />
            </span>
          </Style.PriceDescription>

          <Style.PriceValue>
            <Style.TotalWrapper>
              <em>{currency.moneySign}</em>
              <CurrencyFormat
                value={contact.proposalValue}
                displayType="text"
                thousandSeparator={currency.thousandSeparator}
                decimalSeparator={currency.decimalSeparator}
                decimalScale={2}
                fixedDecimalScale
              />
              /
              <FormattedMessage id="smb_acquisition_commons.frequency.monthly" />
            </Style.TotalWrapper>
          </Style.PriceValue>
        </Style.PriceRow>
      </Style.CardContent>

      <Style.CardFooter>
        <Style.CardFooterIllustration src={runningGirl} />
      </Style.CardFooter>
    </Style.Card>
  )
}

Card.propTypes = {
  contact: shape({
    employeesNumber: oneOfType([number, string]),
  }).isRequired,
}
